export interface IAPICollectionResponseSingle<T> {
  value: T;
  count: number;
  nextLink?: string;
}
